import React, { useState, useEffect, useRef, useCallback } from 'react';
import { MOUSE_DOWN_EVENT } from '../../constant';
import { ChevronIcon } from '../../appearence/icons/chevron_icon';
import SelectWithTokensActiveItem from '../../shared/SelectWithTokensActiveItem';
import SelectWithTokensInput from '../../shared/SelectWithTokensInput';
import SelectWithTokensSelectList from '../../shared/SelectWithTokensSelectList';
import { useTranslation } from 'react-i18next';

const checkSelectedForms = (selectWithTokensManager) => {
    return selectWithTokensManager.getCurrentItems() && selectWithTokensManager.getCurrentItems().length;
};

const PreferenceStructureGroup = ({ selectWithTokensManager }) => {
    const { i18n } = useTranslation();
    const [selectListIsOpen, setSelectListIsOpen] = useState(false);
    const [selectedListIsChanged, setSelectedListIsChanged] = useState(null);
    const wrapperRef = useRef();

    const openItemsList = () => {
        setSelectListIsOpen(true);
    };

    const handleClickOutside = useCallback((event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setSelectListIsOpen(false);
        }
    }, []);

    const changeSelected = () => {
        setSelectedListIsChanged(!selectedListIsChanged);
    };

    useEffect(() => {
        document.addEventListener(MOUSE_DOWN_EVENT, handleClickOutside);
        selectWithTokensManager.registerItemsChangingObserver(changeSelected);
        return () => {
            document.removeEventListener(MOUSE_DOWN_EVENT, handleClickOutside);
            selectWithTokensManager.unRegisterItemsChangingObserver(changeSelected);
        };
    }, []);

    return (
        <label className="block__text preference__form-label">
            <span>{i18n.t('app.page.preference.addTitles.preferenceLabels')}</span>
            <label className="block__text product__form-label">
                <div ref={wrapperRef}>
                    <div className="product__forms relative mt-0 flex min-h-[46px] w-full cursor-pointer flex-wrap items-start justify-between rounded-input border border-solid border-light-grey bg-white px-16 py-8" onClick={openItemsList} >
                        {checkSelectedForms(selectWithTokensManager) ?
                            <ul className={`product__forms-list ${selectWithTokensManager.getCurrentItems().length === 0 ? 'product__forms-list_full-width' : ''}`}>
                                {selectWithTokensManager.getCurrentItems().map((it, index) => (
                                    <React.Fragment key={it.itemId + 'ingredient' + index}>
                                        <SelectWithTokensActiveItem 
                                            selectItem={it}
                                            removeCallback={selectWithTokensManager}
                                        />
                                    </React.Fragment>
                                ))}
                                    
                            </ul>
                            :
                            null}
                        {selectListIsOpen || selectWithTokensManager.getCurrentItems().length === 0 ? 
                            <SelectWithTokensInput selectWithTokensManager={selectWithTokensManager} />
                            :
                            null}
                        <ChevronIcon nameOfClass={`product__forms-icon ${selectListIsOpen ? 'product__forms-icon_active' : ''}`} />
                    </div>
                    {selectListIsOpen ? 
                        <div className="product__forms-dropdown product__select-dropdown">
                            <SelectWithTokensSelectList selectWithTokensManager={selectWithTokensManager} include={true}/>
                        </div>
                        :
                        null}
                </div>
            </label>
        </label>
    );
};

export default PreferenceStructureGroup;
